import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiCall } from "../../../API";



export const getAllStockTransferToOtherShopAction = createAsyncThunk(

    "StockTransferToOtherShop/GetAllStockTransferToOtherShop",
    async (data) => {
        return apiCall("stocktransfer", "POST", data, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {

                        return {
                            ...response.data,
                        }
                    } else {
                        return Promise.reject({
                            ...response.data.message,
                        });
                    }
                }
            })
            .catch((error) => {
                return Promise.reject({
                    ...error,
                });
            });
    }
);

export const getAllActiveBusinessData = createAsyncThunk(
    "StockTransferToOtherShop/businesses",
    async (data) => {
        return apiCall("business/GetActive", "GET", {}, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {
                        return {
                            ...response.data,
                        }
                    } else {
                        return Promise.reject({
                            ...response.data.message,
                        });
                    }
                }
            })
            .catch((error) => {
                return Promise.reject({
                    ...error,
                });
            });
    }
);


export const insertUpdateTransferToOtherShopAction = createAsyncThunk(
    "StockTransferToOtherShop/insertupdatestocktransfer",
    async (data) => {

    
        return apiCall("stocktransfer/add", "POST", data, false)
            .then((response) => {
                if (response.status === 200) {
        
                    if (!response.data.hasError) {
                        let message = response.data.message
                        return {
                            data: {
                                ...response.data,
                            },
                            message: {
                                code: response.data.message.code,
                                type: response.data.message.type,
                                message: response.data.message.message
                            },
                            newRecord: data.id ? false : true
                        }
                    } else {
                        if (!response.data.message && response.data.errors && response.data.errors.length) {
                            response.data.message = response.data.errors[0];
                        }
                        return Promise.reject({
                            ...response.data.message,
                        });
                    }
                }
                else {
                    return Promise.reject({
                        ...response.data,
                    });
                }
            })
            .catch((error) => {
                return Promise.reject({
                    ...error,
                });
            });
    }
);

export const getAllStockTransferToOtherShopByBarcodeAction = createAsyncThunk(

    "StockTransferToOtherShop/GetAllStockTransferToOtherShopByBarcode",
    async (data) => {
        return apiCall("StockTransfer/GetProductStockTransferByBarcode", "POST", data, false)
            .then((response) => {
                if (response.status === 200) {
                
                    if (!response.data.hasError) {

                        return {
                            ...response.data,
                        }
                    } else {
                        return Promise.reject({
                            ...response.data.message,
                        });
                    }
                }
            })
            .catch((error) => {
                return Promise.reject({
                    ...error,
                });
            });
    }
);


export const getStockTransferToOtherShopAction = createAsyncThunk(
    "StockTransferToOtherShop/GetStockTransferToOtherShop",
    async (data) => {
      return apiCall("stocktransfer/getstocktransfer", "POST", data, false)
        .then((response) => {
          if (response.status === 200) {
            if (!response.data.hasError) {
              return {
                ...response.data,
              }
            } else {
              return Promise.reject({
                ...response.data.message,
              });
            }
          }
        })
        .catch((error) => {
          return Promise.reject({
            ...error,
          });
        });
    }
  );
